import React from 'react';
import PropTypes from 'prop-types';

import config from 'config';
import CustomSelect from 'components/select';
import { getMemberRoleId } from '../../../../../utils/General';


const MemberRole = ({ member, updateRole }) => (
  <CustomSelect
    wrapperStyles={{ boxShadow: 'none', display: 'inline-block' }}
    titleStyles={{ color: '#09183A' }}
    listStyles={{ boxShadow: 'none' }}
    options={config.roles}
    handleSelect={updateRole}
    selected={getMemberRoleId(member)}
    width="100px"
  />
);

MemberRole.propTypes = {
  member: PropTypes.object.isRequired,
  updateRole: PropTypes.func.isRequired,
};

export default MemberRole;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/members/MemberRole.jsx